import { render, staticRenderFns } from "./PlatformPieChart.vue?vue&type=template&id=1df0d95f&scoped=true"
import script from "./PlatformPieChart.vue?vue&type=script&lang=js"
export * from "./PlatformPieChart.vue?vue&type=script&lang=js"
import style0 from "./PlatformPieChart.vue?vue&type=style&index=0&id=1df0d95f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df0d95f",
  null
  
)

export default component.exports